import Voip from "./Voip.js";
import Devops from "./Devops.js";
import QAServices from "./QAServices.js";
import WebDesign from "./WebDesign.js";
import MobileApp from "./MobileApp.js";
import AiMlDevelop from "./AiMlDevelop.js";
import OTTServices from "./OttServices.js";

function Offerings() {
  return (
    <div className="Offerings">
       <Devops />
      <Voip />
      {/* <WebDesign /> */}
      {/* <MobileApp />  */}
      {/* <Devops /> */}
      {/* <QAServices /> */}
      <AiMlDevelop />
      <OTTServices />
    </div>
  );
}

export default Offerings;
